import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=16771180&"
import script from "./EmployeeForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16771180')) {
      api.createRecord('16771180', component.options)
    } else {
      api.reload('16771180', component.options)
    }
    module.hot.accept("./EmployeeForm.vue?vue&type=template&id=16771180&", function () {
      api.rerender('16771180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/modules/EmployeeForm.vue"
export default component.exports